import React, { type FC } from 'react';
import classnames from 'classnames';
import styles from './Poll.module.css';
import {
  PollSelectionType,
  type IPollChoice,
  type IPollQuestion,
} from './records';

interface Props {
  question: IPollQuestion;
  selectedChoiceIds: string[];
  onSelectChoice: (choice: IPollChoice) => void;
}

const MultipleChoice: FC<Props> = ({
  question,
  selectedChoiceIds,
  onSelectChoice,
}) => {
  const singleSelection = question.selection_type === PollSelectionType.Single;

  return (
    <form className={styles.choices}>
      {question.choices
        .map((choice: IPollChoice, index: number) => (
          <div
            key={choice.id || index}
            onClick={() => onSelectChoice(choice)}
            onTouchStart={() => onSelectChoice(choice)}
            className={classnames(styles.choice, {
              [styles.answered]: selectedChoiceIds?.includes(choice.id),
            })}
          >
            <input
              type={singleSelection ? 'radio' : 'checkbox'}
              name={'poll-choice'}
              checked={selectedChoiceIds?.includes(choice.id)}
              onChange={e => e.preventDefault()}
            />
            {choice.value}
          </div>
        ))
        .toArray()}
    </form>
  );
};

export default MultipleChoice;
